























helpers = require('../../helpers.coffee')

view_model =
  data: ->
    name: ''

  methods:
    submit: ->
      @$validator.validateAll({@name}).then (success) =>
        @createTemplateCategory() if success

    createTemplateCategory: ->
      Loader.on()
      new TemplateCategoriesResource(Session.current_company.id).create(@createTemplateCategorySuccess, @handleApiErrors, {@name})

    createTemplateCategorySuccess: (data) ->
      Loader.off()
      alertify.success 'Salvo com sucesso'
      @$emit('created', data.template_category)
      @$store.commit 'addTemplateCategory',  data.template_category
      @name = ''
      @$nextTick =>
        @errors.clear()
      IntercomCtrl.trackEvent('Criou uma categoria de template', { 'Nome': data.template_category.name })

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/template_categories/new.vue